<template>
  <footer class="footer" :style="{ background: backgroundColor }">
    <div class="footer-bottom" :style="{ background: backgroundColor }">
      <div class="container">
        <div class="legal-info">
          <span class="company-name">{{ bottomInfo.company_name }}</span>
          <span class="icp-info">{{ bottomInfo.beian }}</span>
          <span class="security-info">
            <i class="security-icon" />
            京公网安备：{{ bottomInfo.wangan }}
          </span>
          <span class="license-info">增值电信业务经营许可证：{{ bottomInfo.xukezheng }}</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { getBottomInfo } from '@/api/user'

export default {
  name: 'Footer',
  props: {
    backgroundColor: {
      type: String,
      default: '#E9E9E9'
    }
  },
  data() {
    return {
      bottomInfo: {
        beian: '',
        company_name: '',
        wangan: '',
        xukezheng: ''
      }
    }
  },
  created() {
    this.fetchBottomInfo()
  },
  methods: {
    async fetchBottomInfo() {
      try {
        const response = await getBottomInfo()
        if (response && response.data) {
          const d = response.data
          this.bottomInfo = {
            beian: d.beian || '',
            company_name: d.company_name || '',
            wangan: d.wangan || d.wang_an || '',
            xukezheng: d.xukezheng || d.telecom_license || ''
          }
        }
      } catch (error) {
        console.error('获取底部信息失败:', error)
        this.bottomInfo = {
          beian: '京IPC123581号-1',
          company_name: '北京华东科技有限公司',
          wangan: '',
          xukezheng: ''
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  color: #333;
  font-family: 'Microsoft YaHei', sans-serif;
  padding: 16px 10%;
  width: 100%;
  box-sizing: border-box;
}

.footer-bottom {
  background: #E9E9E9;
}

.container {
  margin: 0 auto;
}

.legal-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 20px;
  color: #999;
  width: 100%;

  .company-name {
    font-weight: 500;
    color: #999;
  }

  .icp-info {
    color: #999;
  }

  .security-info {
    display: flex;
    align-items: center;
    gap: 5px;

    .security-icon {
      width: 16px;
      height: 16px;
      background: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMUM0LjEzNCAxIDEgNC4xMzQgMSA4QzEgMTEuODY2IDQuMTM0IDE1IDggMTVDMTEuODY2IDE1IDE1IDExLjg2NiAxNSA4QzE1IDQuMTM0IDExLjg2NiAxIDggMVoiIHN0cm9rZT0iIzY2NjY2NiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNiA4TDEwIDhNOCA2VjEwIiBzdHJva2U9IiM2NjY2NjYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+')
        no-repeat center;
      background-size: contain;
    }
  }

  .license-info {
    color: #999;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 12px 5%;
  }

  .legal-info {
    flex-direction: column;
    gap: 10px;
    text-align: center;
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .footer {
    padding: 10px 3%;
  }

  .legal-info {
    font-size: 14px;
  }
}
</style>
